let googleMapsLoaderPromise = null;

function loadGoogleMapsSDK(apiKey) {
    if (googleMapsLoaderPromise) return googleMapsLoaderPromise;

    googleMapsLoaderPromise = new Promise((resolve) => {
        const callbackName = "__googleMapsCallback__";
        window[callbackName] = () => resolve();

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=${callbackName}&v=weekly&libraries=marker&loading=async`;
        script.async = true;
        script.defer = true;
        document.head.append(script);
    });

    return googleMapsLoaderPromise;
}

const BranchesMap = function (scope) {
    scope.branchesMap = this;

    let getPointers;
    if (scope.dataset.pointersJson) {
        try {
            const localData = JSON.parse(scope.dataset.pointersJson);
            getPointers = Promise.resolve(localData);
        } catch (e) {
            console.error("Invalid JSON in data-pointers-json ", e);
            getPointers = Promise.resolve([]);
        }
    } else {
        getPointers = fetch(scope.dataset.pointersUrl)
            .then(response => response.json());
    }

    const apiKey = atob(scope.dataset.subscriptionKey); 
    const mapId = scope.dataset.branchesMapId || "DEMO_MAP_ID";
    const zoomLevel = parseInt(scope.dataset.mapZoom) || 12;

    let centerCoords = { lat: 0, lng: 0 };
    if (scope.dataset.mapCentre) {
        const parts = scope.dataset.mapCentre.split(",").map(Number);
        centerCoords = { lat: parts[1], lng: parts[0] };
    }

    loadGoogleMapsSDK(apiKey).then(async () => {
        const { Map } = await google.maps.importLibrary("maps");
        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        const map = new Map(scope, {
            center: centerCoords,
            zoom: zoomLevel,
            mapId: mapId,
            mapTypeControl: true,       
            zoomControl: true,          
            scaleControl: true,         
            rotateControl: true,        
            fullscreenControl: true,
            gestureHandling: "cooperative",
            clickableIcons: false
        });

        getPointers.then(locations => {
            if (!locations || locations.length === 0) return;

            const bounds = new google.maps.LatLngBounds();

            locations.forEach(location => {
                const lat = parseFloat(location.lat);
                const lng = parseFloat(location.lon);
                const position = { lat, lng };

                bounds.extend(position);

                const markerContainer = document.createElement("div");
                markerContainer.style.display = "flex";
                markerContainer.style.flexDirection = "column";
                markerContainer.style.alignItems = "center";

                const pinImg = document.createElement("img");
                pinImg.src = "/images/northgate-pin.png";
                pinImg.alt = "Northgate Map Pin";
                pinImg.style.width = "32px"; 
                pinImg.style.height = "auto";
                markerContainer.appendChild(pinImg);

                if (location.title) {
                    const label = document.createElement("span");
                    label.textContent = location.title;
                    label.style.fontFamily = "sans-serif";
                    label.style.fontSize = "12px";
                    label.style.fontWeight = "600";
                    label.style.color = "#333";
                    label.style.backgroundColor = "rgba(255,255,255,0.85)";
                    label.style.padding = "2px 6px";
                    label.style.borderRadius = "4px";
                    label.style.marginTop = "4px";
                    label.style.boxShadow = "0 1px 3px rgba(0,0,0,0.2)";
                    markerContainer.appendChild(label);
                }

                new AdvancedMarkerElement({
                    map: map,
                    position: position,
                    title: location.title || "",
                    content: markerContainer,
                });
            });
            
            if (locations.length === 1) {
                map.setCenter({ lat: parseFloat(locations[0].lat), lng: parseFloat(locations[0].lon) });
                map.setZoom(zoomLevel);
            } else {
                map.fitBounds(bounds, {
                    top: 50,
                    right: 50,
                    bottom: 50,
                    left: 50
                });
            }
        });
    });
};

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-branches-map]").forEach(elm => new BranchesMap(elm));
});